const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;

function isLocal() {
  return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
}

function loadPixel() {
  if (!FB_PIXEL_ID || window.fbq || isLocal()) return;

  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = true; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', FB_PIXEL_ID);
  window.fbq('track', 'PageView');
}

function trackPageView() {
  if (window.fbq) window.fbq('track', 'PageView');
}

function trackEvent(event, data) {
  if (window.fbq) window.fbq('track', event, data);
}

export { loadPixel, trackPageView, trackEvent };
